import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23928306&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=23928306&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=23928306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23928306",
  null
  
)

export default component.exports